<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
				style="margin-bottom:15px;display: flex;align-items: center;">
				<h4 class="application-title" style="font-weight: bold;">{{translate(locale.new_unit)}}</h4>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
				style="margin-bottom:15px; display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<form-input v-model="unit.name" :label="locale.unit_name" />
						</div>
					</div>
				</container>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
				style="margin-bottom:15px">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="error-text">
								<p v-for="e in errors">* {{translate(e)}}</p>
							</div>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="createUnit()">{{translate(locale.create_unit)}}</md-button>
						</div>
					</div>
				</container>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				unit: { name: "" },
				errors: []
			}
		},
		methods: {
			createUnit() {

				if (!this.checkValidation()) {
					return;
				}

				this.$http.post(this.config.api + "/user/unit/post", {
					unit: this.unit
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have created an unit successfully.||អ្នកបានបង្កើតអង្គភាពដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/units");
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.unit.name).length <= 0) this.errors.push("Please fill in Unit Name.||សូមបំពេញ ឈ្មោះអង្គភាព។");

				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Units/New.vue